import { css } from "styled-components";

export const cardContainerStyle = css`
	width: 100%;
	display: block;
	position: relative;
	overflow: hidden;
	font-weight: normal;
`
